'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Toolkit(eyebrow, title, lead, items) {
  this.ib = null;
  this.ie = null;
  this.id = null;
  this.ic = null;
  this.ib = eyebrow;
  this.ie = title;
  this.id = lead;
  this.ic = items;
}
export { $c_Lio_intela_sites_intelacloud_content_Toolkit as $c_Lio_intela_sites_intelacloud_content_Toolkit };
$p = $c_Lio_intela_sites_intelacloud_content_Toolkit.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Toolkit;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Toolkit() {
}
export { $h_Lio_intela_sites_intelacloud_content_Toolkit as $h_Lio_intela_sites_intelacloud_content_Toolkit };
$h_Lio_intela_sites_intelacloud_content_Toolkit.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-735933492), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Toolkit)) {
    if ((this.ib === x$0.ib)) {
      var x = this.ie;
      var x$2 = x$0.ie;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.id === x$0.id))) {
      var x$3 = this.ic;
      var x$4 = x$0.ic;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 4;
});
$p.I = (function() {
  return "Toolkit";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ib;
      break;
    }
    case 1: {
      return this.ie;
      break;
    }
    case 2: {
      return this.id;
      break;
    }
    case 3: {
      return this.ic;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Toolkit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bM)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Toolkit as $isArrayOf_Lio_intela_sites_intelacloud_content_Toolkit };
var $d_Lio_intela_sites_intelacloud_content_Toolkit = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Toolkit, "io.intela.sites.intelacloud.content.Toolkit", ({
  bM: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Toolkit as $d_Lio_intela_sites_intelacloud_content_Toolkit };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Toolkit.js.map
